import classnames from 'classnames'
import EstimatedValueTeaser from '../EstimatedValueTeaser'
import ExtraPrincipalTeaser from '../ExtraPrincipalTeaser'
import InterestTeaser from '../InterestTeaser'
import PurchasePowerTeaser from '../PurchasePowerTeaser'
import styles from './HomeownerReportTeaser.module.scss'

const Row = props => <div className={styles.row} {...props} />

export const HomeownerReportTeaser = () => (
  <div>
    <Row>
      <EstimatedValueTeaser.Text className={styles.text} />
      <EstimatedValueTeaser.Screen className={classnames(styles.screen, styles.nonOverflow)} />
    </Row>

    <Row>
      <InterestTeaser.Text className={styles.text} />
      <InterestTeaser.Screen className={classnames(styles.screen, styles.nonOverflow)} />
    </Row>

    <Row>
      <PurchasePowerTeaser.Text className={styles.text} />
      <PurchasePowerTeaser.Screen className={styles.screen} />
    </Row>

    <Row>
      <ExtraPrincipalTeaser.Text className={styles.text} />
      <ExtraPrincipalTeaser.Screen className={classnames(styles.screen, styles.nonOverflow)} />
    </Row>
  </div>
)
